module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/chevron-up-2abcb71a4d39a92ba2d0ff476de78a91.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/chevron-up.svg
// module id = ll/3
// module chunks = 24